import classNames from 'classnames';
import React from 'react';
import { InfoIcon } from '../icons/InfoIcon';
import { WarningIcon } from '../icons/WarningIcon';
import { CrossIcon } from '../icons/CrossIcon';
export var TxAlertType;
(function (TxAlertType) {
    TxAlertType["Error"] = "error";
    TxAlertType["Warning"] = "warning";
    TxAlertType["Info"] = "info";
})(TxAlertType || (TxAlertType = {}));
const ALERT_CONFIG = {
    [TxAlertType.Error]: { Icon: CrossIcon },
    [TxAlertType.Warning]: { Icon: WarningIcon },
    [TxAlertType.Info]: { Icon: InfoIcon },
};
export function TxAlert({ heading, children, iconOverride, className, type = TxAlertType.Warning, }) {
    const Icon = ALERT_CONFIG[type].Icon;
    return (React.createElement("div", { className: classNames('tx-alert', 'tx-alert--' + type, className) },
        React.createElement("div", { className: "tx-alert__icon" }, iconOverride || React.createElement(Icon, null)),
        React.createElement("div", { className: "tx-alert__content" },
            React.createElement("div", { className: "tx-alert__content__heading" }, heading),
            React.createElement("div", { className: "tx-alert__content__body" }, children))));
}
//# sourceMappingURL=Alert.js.map